module.exports = __webpack_public_path__ + "tamboVerde.png?83e2ad89142bf83eb6737826a4e3846c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tamboVerde.png
// module id = 465
// module chunks = 2